import { SvgIcon } from '@mui/material'

const CloseCircle = props => (
  <SvgIcon
    viewBox="0 0 16 16"
    {...props}
    sx={{
      fill: 'none'
    }}
  >
    <circle cx="8" cy="8" r="8" fill="#001229" />
    <rect width="10.6667" height="10.6667" transform="translate(2.6665 2.66669)" fill="#001229" />
    <path
      d="M10.8003 5.20479C10.627 5.03145 10.347 5.03145 10.1736 5.20479L8.00031 7.37368L5.82698 5.20034C5.65365 5.02701 5.37365 5.02701 5.20031 5.20034C5.02698 5.37368 5.02698 5.65368 5.20031 5.82701L7.37365 8.00034L5.20031 10.1737C5.02698 10.347 5.02698 10.627 5.20031 10.8003C5.37365 10.9737 5.65365 10.9737 5.82698 10.8003L8.00031 8.62701L10.1736 10.8003C10.347 10.9737 10.627 10.9737 10.8003 10.8003C10.9736 10.627 10.9736 10.347 10.8003 10.1737L8.62698 8.00034L10.8003 5.82701C10.9692 5.65812 10.9692 5.37368 10.8003 5.20479Z"
      fill="white"
    />
  </SvgIcon>
)

export default CloseCircle
